<template>
  <div>
    <div class="topheader">
      <div class="topheader__logo">
        <img src="./../../../assets/images/hrdesk-logo-dark-beta.png" alt="logo" />
      </div>
      <div class="topheader__contact">
        <div class="topheader__contact--phone">
          <routerLink to="/">Sign up</routerLink>
        </div>
        <div class="topheader__contact--login">
          <routerLink to="/login">Login to hrdesk</routerLink>
        </div>
      </div>
    </div>

    <section id="feature1" class="section feature feature-center bg-white">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-6 offset-lg-3" id="calendar">
            <div class="calendly-inline-widget" data-url="https://calendly.com/hrdesk/lets-talk"
              style="min-width:320px;height:630px;"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Calendar",
  mounted() {
    const calendly = document.createElement("script");
    calendly.setAttribute(
      "src",
      "//assets.calendly.com/assets/external/widget.js"
    );
    document.getElementById("calendar").appendChild(calendly);
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../assets/vendor/css/external.css";
@import "./../../../assets/vendor/css/style.css";

.topheader {
  min-height: 80px;
  margin: auto;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border-bottom: 1px solid #efeff1;

  @media (max-width: 750px) {
    flex-direction: column;
  }

  >.topheader__logo {
    max-width: 150px;

    >img {
      width: 100%;
    }
  }

  >.topheader__contact {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    align-content: center;

    @media (max-width: 750px) {
      flex-direction: column;
    }

    >.topheader__contact--email {
      max-width: 230px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: #6262a0;
      padding: 0;

      >a {
        color: #6262a0;
        text-decoration: none;
      }
    }

    >.topheader__contact--phone {
      max-width: 150px;
      font-size: 16px;
      text-align: center;
      font-weight: 400;
      color: #6262a0;
      padding: 0;

      >a {
        color: #6262a0;
        text-decoration: none;
      }
    }

    >.topheader__contact--login {
      width: 120px;
      font-size: 16px;
      font-weight: 600;
      color: #f79320;
      padding: 0;

      >a {
        color: #f79320;
        text-decoration: none;
      }
    }
  }
}
</style>
